import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IPageInfo, IEmployeeImportVersion, IEmployeeImportFailed } from '@api'
import {
  PageInfoFragment,
  EmployeeImportVersionFragment,
  EmployeeImportFailedFragment,
} from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  node: {
    createdAt: string
    importedBy: string
    employee_import_versions: {
      pageInfo: IPageInfo
      edges: { node: IEmployeeImportVersion }[]
    }
    employee_import_errors: {
      pageInfo: IPageInfo
      edges: {
        node: {
          failed: IEmployeeImportFailed
        }
      }[]
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, any>({
  handler: (data) => {
    const {
      createdAt,
      importedBy,
      employee_import_errors: { edges: errorEdges },
      employee_import_versions: { pageInfo, edges },
    } = data.node

    const formattedFailed = errorEdges.map((edge) => edge.node).filter((node) => node.failed)
    const failed = formattedFailed.map((failedObj: any) => {
      return { ...failedObj['failed'][0] }
    })
    return {
      details: edges.map(({ node }: { node: IEmployeeImportVersion }) => node),
      pageInfo,
      failed,
      createdAt,
      importedBy,
    }
  },
  name: 'Employee Import Version',
})

export default function details(
  id: string,
  after: string | null,
  events: string[]
): Promise<{
  details: IEmployeeImportVersion[]
  pageInfo: IPageInfo
  failed: IEmployeeImportFailed[]
  createdAt: string
  importedBy: string
  employeeImportErrors: string[]
}> {
  return client.gql.query({ query, variables: { id, after, events } }).then(mutateHandler)
}

const query = gql`
  query node($id: ID!, $after: String, $errorAfter: String, $events: [EmployeeImportEvent]!) {
    node(id: $id) {
      ... on EmployeeImport {
        createdAt
        importedBy

        employee_import_errors(first: 500, after: $errorAfter) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              failed {
                ...EmployeeImportFailedFragment
              }
            }
          }
        }

        employee_import_versions(first: 30, after: $after, events: $events) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...EmployeeImportVersionFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${EmployeeImportVersionFragment}
  ${EmployeeImportFailedFragment}
`
